import React from 'react';

const Idaho = () => {
  return (
    <div>
      
    </div>
  );
}

export default Idaho;
